<template>
  <div class="cards sk-cards">
    <article v-for="n in count" :key="'pf-' + n" class="sk-card">
      <div class="sk sk-img" />
      <div class="sk sk-line sk-h" />
      <div class="sk sk-line sk-sm" />
      <div class="sk-meta">
        <div class="sk sk-line sk-chip" /><div class="sk sk-line sk-chip sk-chip--2" />
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: "PublicFeaturedSkeleton",
  props: { count: { type: Number, default: 3 } },
};
</script>

<style scoped>
.sk-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}
@media (max-width: 900px) {
  .sk-cards {
    grid-template-columns: 1fr;
  }
}
.sk-card {
  background: #152338;
  border-radius: 16px;
  padding: 0 0 18px;
  overflow: hidden;
  border: 1px solid #1e3352;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}
.sk-img {
  height: 180px;
  border-radius: 0;
  margin-bottom: 14px;
}
.sk-h {
  height: 20px;
  width: 80%;
  margin: 0 18px 10px;
}
.sk-sm {
  height: 13px;
  width: 50%;
  margin: 0 18px 12px;
}
.sk-meta {
  display: flex;
  gap: 10px;
  padding: 0 18px;
}
.sk-chip {
  height: 14px;
  width: 56px;
  margin-bottom: 0;
}
.sk-chip--2 {
  width: 72px;
}
</style>
